import { PropsWithChildren } from "react";
import { BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME } from "./bookview-tab-panel";
import Button from "atoms/buttons/button";
import React from "react";
import { ButtonStyles } from "atoms/constants/button-styles";
import { t } from "utilities/localization-utils";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
interface BookviewTabPanelFooterProps extends PropsWithChildren {
    isInLegacyPublicationView?: boolean;
}
const BookviewTabPanelFooter: React.FC<BookviewTabPanelFooterProps> = ({
    children,
    isInLegacyPublicationView,
}) => {
    const { handleClose } = useBookviewTabPanel();
    return (
        <div
            className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__footer ${isInLegacyPublicationView ? "-compact" : ""}`}>
            <Button style={ButtonStyles.Tertiary} onClick={handleClose}>
                {t("close")}
            </Button>
            {children}
        </div>
    );
};

export default BookviewTabPanelFooter;
